import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_FAIL,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
} from "../actionTypes";

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        loading: true,
        didLogout: false,
      };
    case USER_LOGIN_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
        didLogout: false,
      };
    case USER_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
        didLogout: false,
      };
    case USER_LOGOUT:
      return { didLogout: true };
    default:
      return state;
  }
};
